<template>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="CompanyInfo">
        <el-tab-pane label="保养计划" name="first">
            <div style="padding:5px 5px 5px 5px">
                <!-- <div id="create_maintain" style="display:inline-block"><el-button round
                        @click="openDialog">新增保养</el-button>
                </div> -->

                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>计划列表</b></p>

                    <div style="display:inline-block">
                        <el-radio-group v-model="statusSearch" @input="searchByStatus" size="small">
                            <el-radio-button label="0">未确认</el-radio-button>
                            <el-radio-button label="1">被驳回</el-radio-button>
                            <el-radio-button label="2">待保养</el-radio-button>
                            <el-radio-button label="3">正在保养</el-radio-button>
                            <el-radio-button label="4">保养完成</el-radio-button>
                            <el-radio-button label="-1">全部</el-radio-button>
                        </el-radio-group>
                    </div>

                    <p style="display:inline;float: right;width:10px"></p>
                    <div style="display:inline-block;float:right;">
                        <el-button icon="el-icon-download" type="text" @click="exportExcel">导出Excel </el-button>
                    </div>
                    <p style="display:inline;float: right;width:10px"></p>
                    <p style="display:inline;float: right;line-height: 22px;">
                        <el-button size="mini" round @click="openDialog">新增保养</el-button>
                    </p>
                </div>

            </div>

            <template>
                <el-table :data="maintainList" style="width: 100%" max-height="500">
                    <el-table-column fixed prop="type" label="类型" width="80">
                    </el-table-column>
                    <el-table-column prop="codeAndName" label="编号&名称" width="180">
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="100">
                    </el-table-column>
                    <el-table-column prop="programNameStr" label="保养项目" width="180">
                    </el-table-column>
                    <el-table-column prop="applicant" label="申请人" width="100">
                    </el-table-column>
                    <el-table-column prop="maintainer" label="保养人" width="100">
                    </el-table-column>
                    <el-table-column prop="maintainCycle" label="保养周期(天)" width="100">
                    </el-table-column>
                    <el-table-column prop="maintainCount" label="保养模数" width="100">
                    </el-table-column>
                    <el-table-column prop="planMaintainTime" label="计划保养时长(小时)" width="150">
                    </el-table-column>
                    <el-table-column prop="createdTime" label="创建时间" width="150">
                    </el-table-column>
                    <el-table-column prop="confirmTime" label="确认时间" width="150">
                    </el-table-column>
                    <el-table-column prop="startTime" label="开始保养时间" width="150">
                    </el-table-column>
                    <el-table-column prop="completeTime" label="完成保养时间" width="150">
                    </el-table-column>
                    <el-table-column prop="applicantRemark" label="申请人备注" width="180">
                    </el-table-column>
                    <el-table-column prop="maintainerRemark" label="保养人备注" width="180">
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="checkClick(scope.row)" type="text" size="small" style="color:#6f5499">
                                查看
                            </el-button>
                            <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color:orange">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>

            <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="60%">
                <el-form :inline="true" :model="form" :rules="rules" :disabled="maintainFormDisable"
                    class="demo-ruleForm">

                    <el-form-item label="类型" :label-width="formLabelWidth">
                        <el-select v-model="equipmentTypeValue" placeholder="请选择" @change="selectEquipmentType">
                            <el-option v-for="item in form.equipmentType" :key="item.value" :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <div style="width:350px;display: inline-block;">
                        <el-form-item label="选择机器" :label-width="formLabelWidth" v-if="equipmentSelectVisible">
                            <el-select v-model="equipmentCodeName" placeholder="请选择">
                                <el-option v-for="item in form.equipmentList" :key="item.value"
                                    :label="item.equipmentCode + item.equipmentName"
                                    :value="item.equipmentCode + item.equipmentName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <div style="padding:0">
                        <el-form-item label="保养项目" :label-width="formLabelWidth">
                            <el-input v-model="programNameStr" autocomplete="off" v-if="programNameStr"
                                style="width:536px"></el-input>

                            <el-select v-model="programIdArr" multiple placeholder="请选择" v-if="programSelectVisible"
                                style="width:536px">
                                <el-option v-for="item in maintainProgramList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <el-form-item label="周期累计方式" :label-width="formLabelWidth" v-if="cycleTypeVisible">
                        <el-select v-model="cycleTypeValue" placeholder="请选择" @change="selectCycleType">
                            <el-option v-for="item in form.cycleType" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <div :style="cycleStyle">
                        <el-form-item label="保养周期(天)" :label-width="formLabelWidth" v-if="cycleSelectVisible">
                            <el-input-number v-model="form.maintainCycle" :step="1" :min="1"
                                style="width:193px"></el-input-number>
                        </el-form-item>
                        <el-form-item label="保养模数" :label-width="formLabelWidth" v-if="countSelectVisible">
                            <el-input-number v-model="form.maintainCount" :step="1" :min="1"
                                style="width:193px"></el-input-number>
                        </el-form-item>
                    </div>

                    <el-form-item label="计划保养用时(小时)" :label-width="formLabelWidth">
                        <el-input-number v-model="form.planMaintainTime" :precision="1" :step="1" :min="0.1"
                            style="width:193px"></el-input-number>
                    </el-form-item>

                    <el-form-item label="保养人" :label-width="formLabelWidth">
                        <el-select v-model="form.maintainer" placeholder="请选择">
                            <el-option v-for="item in form.empList" :key="item.value" :label="item.employeeName"
                                :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="申请人备注" :label-width="formLabelWidth">
                        <el-input v-model="form.applicantRemark" autocomplete="off" type="textarea"
                            style="width:536px"></el-input>
                    </el-form-item>

                    <!-- <el-form-item label="保养人备注" :label-width="formLabelWidth" v-if="maintainerRemarkVisible">
                        <el-input v-model="form.maintainerRemark" autocomplete="off" type="textarea" :disabled="maintainerRemarkDisable"
                            style="width:550px"></el-input>
                    </el-form-item> -->
                </el-form>

                <div v-if="maintainerRemarkVisible">
                    <p style="display:inline-block;width:120px;text-align:right;padding:0 12px 0 0">保养人备注</p>
                    <el-input v-model="form.maintainerRemark" autocomplete="off" type="textarea"
                        :disabled="maintainerRemarkDisable" style="width:550px"></el-input>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button @click="editClick" v-if="editButtonVisible">编 辑</el-button>
                    <el-button @click="rejectClick" v-if="rejectButtonVisible">驳 回</el-button>
                    <el-button type="primary" @click="addMaintain" v-if="saveButtonVisible">保 存</el-button>
                    <el-button type="primary" @click="modifyMaintain" v-if="modifyButtonVisible">保 存</el-button>
                    <el-button type="primary" @click="confirmClick" v-if="confirmButtonVisible">确认保养</el-button>
                    <el-button type="primary" @click="startClick" v-if="startButtonVisible">开始保养</el-button>
                    <el-button type="primary" @click="completeClick" v-if="completeButtonVisible">完成保养</el-button>
                </div>
            </el-dialog>
        </el-tab-pane>

        <el-tab-pane label="保养项目" name="second">
            <!-- <p id="create_company"><el-button round @click="openDrawer">新增项目</el-button></p> -->

            <div style="padding:5px 5px 5px 5px">
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>项目列表</b></p>
                    <p style="display:inline;float: right;line-height: 22px;">
                        <el-button size="mini" round @click="openDrawer">新增项目</el-button>
                    </p>
                </div>
            </div>

            <el-row>
                <el-drawer title="新增保养项目" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
                    style="text-align: left;">
                    <p style="padding:0 0 0 10px">项目名称</p>
                    <el-input placeholder="请输入" v-model="programName" clearable
                        style="width:350px;margin: 0 0 0 10px;"></el-input>

                    <div id="cancel_determine">
                        <el-button round @click="drawer = false">取消</el-button>
                        <el-button round type="primary" @click="createMaintainProgram">确认</el-button>
                    </div>
                </el-drawer>
            </el-row>

            <template>
                <el-table :data="maintainProgramList" style="width: 100%" max-height="500">
                    <el-table-column prop="programName" label="项目名称" width="750">
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button @click="editProgramClick(scope.row)" type="text" size="small"
                                style="color:#6f5499">
                                编辑
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    name: "MaintainPlan",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),
            activeName: 'first',
            dialogFormVisible: false,
            editButtonVisible: false,
            rejectButtonVisible: false,
            saveButtonVisible: true,
            modifyButtonVisible: false,
            confirmButtonVisible: false,
            startButtonVisible: false,
            completeButtonVisible: false,
            dialogTitle: '新增保养',
            formLabelWidth: '140px',
            maintainFormDisable: false,
            maintainerRemarkDisable: false,
            form: {
                id: '',
                equipmentType: [{
                    value: 1,
                    label: '机器'
                }, {
                    value: 2,
                    label: '模具'
                }],
                equipmentList: [],
                cycleType: [{
                    value: 1,
                    label: '按时间'
                }, {
                    value: 2,
                    label: '按模数'
                }],
                status: 0,
                maintainCycle: '',
                maintainCount: '',
                planMaintainTime: 1.0,
                empList: [],
                maintainer: '',
                applicantRemark: '',
                maintainerRemark: '',
                statusSearch: ''
            },
            equipmentTypeValue: '',
            cycleTypeValue: '',
            equipmentSelectVisible: false,
            equipmentCodeName: '',
            cycleTypeVisible: true,
            cycleSelectVisible: false,
            countSelectVisible: false,
            maintainList: [],
            drawer: false,
            programName: '',
            maintainProgramList: [],
            programSelectVisible: true,
            programNameStr: '',
            programIdArr: [],
            statusSearch: 0,
            maintainerRemarkVisible: false,
            cycleStyle: {
                display: "inline-block",
                width: "350px"
            }
        }
    },
    methods: {
        handleClick(tab, event) {
            //console.log(tab, event);
            if (tab.index == "1") {
                this.getAllMaintainProgram()
            } else {
                this.getAllMaintain(0)
            }
        },
        openDialog() {
            this.dialogTitle = '新增保养'
            this.equipmentTypeValue = ''
            this.equipmentCodeName = ''
            this.programSelectVisible = true
            this.programNameStr = ''
            this.programIdArr = []
            this.cycleTypeValue = ''
            this.form.maintainCycle = ''
            this.form.maintainCount = ''
            this.form.planMaintainTime = 1.0
            this.form.maintainer = ''
            this.form.applicantRemark = ''
            this.equipmentSelectVisible = false
            this.cycleTypeVisible = true
            this.cycleSelectVisible = false
            this.countSelectVisible = false

            this.cycleStyle.display = "inline-block"

            this.maintainFormDisable = false
            this.editButtonVisible = false
            this.saveButtonVisible = true
            this.modifyButtonVisible = false
            this.rejectButtonVisible = false
            this.confirmButtonVisible = false
            this.startButtonVisible = false
            this.completeButtonVisible = false

            this.maintainerRemarkVisible = false
            this.dialogFormVisible = true
        },
        selectEquipmentType(value) {
            if (value == '机器') {
                this.equipmentSelectVisible = true
                this.getAllEquipment()
            } else {
                this.equipmentSelectVisible = false
            }
        },
        selectCycleType(value) {
            if (value == 1) {
                this.cycleSelectVisible = true
                this.countSelectVisible = false
            } else {
                this.countSelectVisible = true
                this.cycleSelectVisible = false
            }
        },
        getAllEquipment() {
            this.$axios({
                method: "post",
                url: "/shiro/equipment/getAll",
                data: {
                    id: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.equipmentList = data.data

            })
        },
        getAllEmp() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.form.empList = data.data

            })
        },
        addMaintain() {
            this.$axios({
                method: "post",
                url: "/shiro/maintain/add",
                data: {
                    type: this.equipmentTypeValue,
                    codeAndName: this.equipmentCodeName,
                    programIds: this.programIdArr,
                    maintainCycle: this.form.maintainCycle,
                    maintainCount: this.form.maintainCount,
                    planMaintainTime: this.form.planMaintainTime,
                    applicant: this.userId,
                    maintainer: this.form.maintainer,
                    applicantRemark: this.form.applicantRemark,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                this.dialogFormVisible = false
                this.getAllMaintain(this.statusSearch)
            })
        },
        searchByStatus(val) {
            //console.log('bbb')
            //console.log(val)
            this.getAllMaintain(val)
        },
        exportExcel() {
            this.$axios({
                method: "post",
                url: "/shiro/maintain/export",
                data: {
                    status: this.statusSearch,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })
                
                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "设备保养.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        getAllMaintain(val) {
            this.statusSearch = val
            this.$axios({
                method: "post",
                url: "/shiro/maintain/getAll",
                data: {
                    status: val,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.maintainList = data.data
                for (let i in this.maintainList) {
                    this.maintainList[i].createdTime = this.$moment(this.maintainList[i].createdTime).format("YYYY-MM-DD HH:mm")

                    if (this.maintainList[i].confirmTime != null) {
                        this.maintainList[i].confirmTime = this.$moment(this.maintainList[i].confirmTime).format("YYYY-MM-DD HH:mm")
                    }
                    if (this.maintainList[i].startTime != null) {
                        this.maintainList[i].startTime = this.$moment(this.maintainList[i].startTime).format("YYYY-MM-DD HH:mm")
                    }
                    if (this.maintainList[i].completeTime != null) {
                        this.maintainList[i].completeTime = this.$moment(this.maintainList[i].completeTime).format("YYYY-MM-DD HH:mm")
                    }

                    // if (this.maintainList[i].type == '1') {
                    //     this.maintainList[i].type = '机器'
                    // } else {
                    //     this.maintainList[i].type = '模具'
                    // }

                    if (this.maintainList[i].status == 0) {
                        this.maintainList[i].status = '未确认'
                    } else if (this.maintainList[i].status == 1) {
                        this.maintainList[i].status = '被驳回'
                    } else if (this.maintainList[i].status == 2) {
                        this.maintainList[i].status = '待保养'
                    } else if (this.maintainList[i].status == 3) {
                        this.maintainList[i].status = '正在保养'
                    } else if (this.maintainList[i].status == 4) {
                        this.maintainList[i].status = '保养完成'
                    }
                }
            })
        },
        checkClick(row) {
            this.dialogTitle = '查看保养'
            this.cycleTypeVisible = false
            this.cycleSelectVisible = false
            this.countSelectVisible = false

            this.form.id = row.id
            this.equipmentTypeValue = row.type
            this.equipmentCodeName = row.codeAndName
            this.equipmentSelectVisible = true

            this.programSelectVisible = false
            this.programIdArr = row.programIds
            this.programNameStr = row.programNameStr
            //this.cycleTypeValue = row.type
            //this.form.maintainCycle = row.type
            //this.form.maintainCount = row.type
            this.form.planMaintainTime = row.planMaintainTime
            this.form.maintainer = row.maintainerId
            this.form.applicantRemark = row.applicantRemark
            this.form.maintainerRemark = row.maintainerRemark
            this.maintainerRemarkVisible = false

            this.maintainFormDisable = true

            this.cycleStyle.display = "none"
            this.modifyButtonVisible = false
            if (row.status == '未确认') {
                this.saveButtonVisible = false
                this.editButtonVisible = false
                this.rejectButtonVisible = true
                this.confirmButtonVisible = true
                this.startButtonVisible = false
                this.completeButtonVisible = false
            } else if (row.status == '被驳回') {
                this.saveButtonVisible = false
                this.rejectButtonVisible = false
                this.confirmButtonVisible = false
                this.editButtonVisible = true
                this.startButtonVisible = false
                this.completeButtonVisible = false
            } else if (row.status == '待保养') {
                this.saveButtonVisible = false
                this.rejectButtonVisible = false
                this.confirmButtonVisible = false
                this.editButtonVisible = false
                this.startButtonVisible = true
                this.completeButtonVisible = false
            } else if (row.status == '正在保养') {
                this.saveButtonVisible = false
                this.rejectButtonVisible = false
                this.confirmButtonVisible = false
                this.editButtonVisible = false
                this.startButtonVisible = false
                this.completeButtonVisible = true

                this.maintainerRemarkVisible = true
                this.maintainerRemarkDisable = false
            } else {
                this.saveButtonVisible = false
                this.rejectButtonVisible = false
                this.confirmButtonVisible = false
                this.editButtonVisible = false
                this.startButtonVisible = false
                this.completeButtonVisible = false

                this.maintainerRemarkVisible = true
                this.maintainerRemarkDisable = true
            }

            this.dialogFormVisible = true
        },
        modifyMaintain() {
            this.$axios({
                method: "put",
                url: "/shiro/maintain/modify",
                data: {
                    id: this.form.id,
                    type: this.equipmentTypeValue,
                    codeAndName: this.equipmentCodeName,
                    programIds: this.programIdArr,
                    status: this.form.status,
                    planMaintainTime: this.form.planMaintainTime,

                    maintainer: this.form.maintainer,
                    applicantRemark: this.form.applicantRemark,
                    maintainerRemark: this.form.maintainerRemark,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                this.dialogFormVisible = false
                this.getAllMaintain(this.statusSearch)
            })
        },
        rejectClick() {
            this.form.status = 1
            this.modifyMaintain()
        },
        editClick() {
            this.editButtonVisible = false
            this.modifyButtonVisible = true
            this.maintainFormDisable = false

            this.programSelectVisible = true
            this.programNameStr = ''
            this.form.status = 0
        },
        confirmClick() {
            this.form.status = 2
            this.modifyMaintain()
        },
        startClick() {
            this.form.status = 3
            this.modifyMaintain()
        },
        completeClick() {
            this.form.status = 4
            this.modifyMaintain()
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeMaintain(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        removeMaintain(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/maintain/remove",
                data: {
                    id: row.id,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAllMaintain(this.statusSearch)
            })
        },
        openDrawer() {
            this.drawer = true
            this.programName = ''
        },
        createMaintainProgram() {
            this.$axios({
                method: "post",
                url: "/shiro/maintain/program/add",
                data: {
                    programName: this.programName,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                this.drawer = false
                this.getAllMaintainProgram()
            })
        },
        getAllMaintainProgram() {
            this.$axios({
                method: "post",
                url: "/shiro/maintain/program/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.maintainProgramList = data.data
                for (let i in this.maintainProgramList) {
                    this.maintainProgramList[i].value = this.maintainProgramList[i].id
                    this.maintainProgramList[i].label = this.maintainProgramList[i].programName
                }
            })
        },
        editProgramClick(row) { }
    },
    mounted() {
        this.getAllMaintain(this.statusSearch)
        this.getAllMaintainProgram()
        this.getAllEmp()

        //this.maintainForm = document.getElementsByClassName("demo-ruleForm")
        //console.log('ccc')
        //console.log(this.maintainForm)
    }
}
</script>

<style>
#create_maintain {
    /* position: relative;
    right: 25px; */
    float: left;
    width: 120px;
    margin: 0 50px 20px 0;
}
</style>